import {
  BridgeNetwork,
  BridgeOperation,
  BridgeOperationActionType,
  BridgeToken,
  BridgeTokenType,
  confirmOperation
} from "../../api/bridge";
import {approve, estimateSendFee, sendFrom} from "../../api/erc20";
import {parseUnits} from 'viem'
import {networks} from './networks'
import {waitForTransaction} from "@wagmi/core";

export const getTokenConfig = (tokens: BridgeToken[], address: string) => {
  return tokens.find(
    t =>
      t.erc20Address.toUpperCase() === address.toUpperCase() ||
      t.hrc20Address.toUpperCase() === address.toUpperCase(),
  );
}

export const approveEthManager = async (params: {
    operation: BridgeOperation,
    tokens: BridgeToken[]
  }) => {
  const { tokens, operation } = params
  const { erc20Address } = params.operation

  const tokenConfig = getTokenConfig(tokens, erc20Address);

  if(!tokenConfig) {
    throw new Error('No token config')
  }

  const decimals = +tokenConfig.decimals

  if(operation.network === BridgeNetwork.ARBITRUM) {
    const approvalZeroResult = await approve(
      erc20Address,
      tokenConfig.proxyERC20,
      parseUnits('0', decimals)
    )
    console.log('approvalZeroResult:', approvalZeroResult)
    await waitForTransaction({ hash: approvalZeroResult.hash, confirmations: 1 })
  }

  const approvalResult = await approve(
    erc20Address,
    tokenConfig.proxyERC20,
    parseUnits(operation.amount, decimals)
  )
  console.log('approvalResult', approvalResult.hash)
  await waitForTransaction({ hash: approvalResult.hash, confirmations: 1 })
  const confirmResult = await confirmOperation(operation.id, BridgeOperationActionType.approveEthManger, approvalResult.hash)
  return confirmResult
}

export const lockTokenCall = async (params: {
  operation: BridgeOperation,
  tokens: BridgeToken[]
}) => {
  const { tokens, operation } = params
  const { erc20Address } = params.operation

  const tokenConfig = getTokenConfig(tokens, erc20Address);

  if(!tokenConfig) {
    throw new Error('No token config')
  }

  // const - 500k gasLimit
  const adapterParams = tokenConfig.adapterParams || tokenConfig.adapterParamsEth ||
    '0x0001000000000000000000000000000000000000000000000000000000000007a120';

  const amount = parseUnits(operation.amount, +tokenConfig.decimals)

  const sendFee = await estimateSendFee(
    tokenConfig.proxyERC20,
    networks[operation.network].layerzero.chainId,
    operation.ethAddress,
    amount,
    false,
    adapterParams
  )

  let value;
  switch (tokenConfig.token) {
    case BridgeTokenType.ETH:
      value = amount + sendFee.nativeFee;
      break;

    default:
      value = sendFee.nativeFee;
  }

  const txResult = await sendFrom(
    tokenConfig.proxyERC20,
    [
      operation.ethAddress,
      networks.HARMONY.layerzero.chainId,
      operation.ethAddress,
      amount,
      operation.ethAddress,
      '0x0000000000000000000000000000000000000000',
      adapterParams
    ],
    value
  )
  console.log('Lock tx:', txResult)
  await waitForTransaction({ hash: txResult.hash, confirmations: 1 })
  return await confirmOperation(operation.id, BridgeOperationActionType.lockToken, txResult.hash)
}
